import React from "react";
import { createRoot } from "react-dom/client";
import { installStorage, storageUsage } from "./storage.js";
import PoolDesk from "./PoolDesk.jsx";

// Must run before the app mounts — PoolDesk reads window.storage on first render.
installStorage();
window.storageUsage = storageUsage;

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <PoolDesk />
  </React.StrictMode>
);
